export default __webpack_public_path__ + "static/media/20-5.58a9c0f3.mp3";